import React from 'react'
import langLists from '../assets/languages'
import { Container, Row, Col } from 'react-bootstrap';

const Languages = () => {
    return (
        <>
            <div className='languages'>
                <Container>
                    <h1 className='section-heading'>Languages</h1>
                    <Row className='row-eq-height'>
                        {langLists.map((item, ind) =>
                            <>
                                
                                    <Col md={3}>
                                        <div className='lang'>
                                            <div className='lang-inner'>
                                                <h4 key={ind}>{item.origin}</h4>
                                                {
                                                    item.langs.map((item1, ind1) =>
                                                        <li>{item1}</li>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                

                            </>
                        )}

                    </Row>
                </Container>
            </div>
        </>
    )
}

export default Languages